module.exports = __webpack_public_path__ + "img/index20.0be31cab.png";